import { Component, OnInit } from '@angular/core';
import{NavParams} from '@ionic/angular';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-edit-verse',
  templateUrl: './edit-verse.component.html',
  styleUrls: ['./edit-verse.component.scss'],
})
export class EditVerseComponent implements OnInit {

  editedVerse:any;
  NewText;


  constructor( public navParams: NavParams,
    private modalCtrl: ModalController,
    ) { }

  ngOnInit() {
     this.editedVerse = this.navParams.get('verse');

  }

   dismiss() {
     this.editedVerse = this.NewText+'<br><br>'+this.editedVerse;
     this.modalCtrl.dismiss({ 'dismissed': true,verse: this.editedVerse});
  }

}
